import React, { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store/hook';
import { selectLmsLists } from '../../store/features/lmsSlice';
import { LoadingSpinner } from '../Loading/LoadingSpinner';
import { Menu } from 'antd';
import { SidebarItems } from './sidebarItem';
import { changeTimestamp } from '../../api/utils/util-func';
import { LMS_COURSE_ID } from '../../constants/types/lms/type';

const Sidebar = ({ classId }: { classId: string }) => {
  const { pathname } = useLocation();
  const lmsLists = useAppSelector(selectLmsLists);
  const [isLoading, setIsloading] = useState(false);

  /**
   * 현재 코스의 분류 결정
   * @description setMenuExposure 함수의 인자
   * - "home" : 젭스영어교실 베이직
   * - "church" : 교회학교 HFHJ, WMW
   * - "" : 그 외
   */
  useEffect(() => {
    setIsloading(true);
    if (lmsLists) {
      setIsloading(false);
    }
  }, [lmsLists]);

  const courseName = useMemo(() => {
    if (classId === lmsLists?.id) {
      switch (lmsLists.course?.id) {
        case LMS_COURSE_ID.KIDS:
          return 'KIDS';
        case LMS_COURSE_ID.BASIC:
          return 'BASIC';
        case LMS_COURSE_ID.ADVANCED:
          return 'ADVANCED';
        case LMS_COURSE_ID.WMW:
          return 'WMW';
        case LMS_COURSE_ID.HFHJ:
          return 'HFHJ';
        default:
          return 'OTHERS';
      }
    }

    return '';
  }, [lmsLists]);

  /**
   * 사이드 메뉴의 하이라이트 표시
   * @returns 현재 메뉴
   */
  const nowMenu = useMemo(() => {
    const urlArr = pathname.split('/');

    if (urlArr.length < 3 || urlArr[1] !== 'lms') {
      console.error('잘못된 접속입니다.', pathname);
      return;
    }

    const base = urlArr[3];
    let subType = urlArr[4];
    switch (base) {
      case 'dashboard':
      case 'course-management':
      case 'take-class':
      case 'voucher':
      case 'membership-store':
      case 'reference-room':
      case 'signup-management':
      case 'event':
        return base;
      case 'assignment':
        subType = urlArr[4];
        return ['create', 'status'].includes(subType)
          ? `${base}-${subType}`
          : undefined;
      case 'recitation':
        subType = urlArr[4];
        return ['create', 'status'].includes(subType)
          ? `${base}-${subType}`
          : undefined;
      case 'migration':
        return 'signup-management';
      default:
        return;
    }
  }, [pathname]);

  return isLoading ? (
    <LoadingSpinner message="데이터 조회중" />
  ) : (
    <div>
      {lmsLists && (
        <div className="border-b bg-gray0 px-5 py-3 xl:bg-white xl:px-7 xl:py-7">
          <Link to="./dashboard">
            <div className="text-lg font-semibold">{lmsLists.course?.name}</div>
          </Link>

          <div className="mt-3 flex flex-col gap-1 text-sm">
            <div className="font-semibold text-gray6">이용 잔여일</div>

            <div className="font-medium text-red5">
              {Number(lmsLists.remain_days) > 0
                ? `${lmsLists.remain_days}일 (${changeTimestamp(
                    lmsLists.end_date,
                  )} 까지)`
                : `${lmsLists.remain_days}일`}
            </div>
          </div>

          <Link
            to="./membership-store"
            className="mt-4 flex h-8 w-full items-center justify-center rounded-lg border border-purple5 bg-white text-sm font-bold text-purple5 transition-colors hover:bg-purple1"
          >
            이용 기간 연장
          </Link>
        </div>
      )}
      <Menu
        mode="inline"
        defaultOpenKeys={['assignment', 'recitation']}
        selectedKeys={[nowMenu]}
        items={SidebarItems(courseName)}
      />
    </div>
  );
};

export default Sidebar;
